import { DateTime } from 'luxon';
import { PaymentMethodType } from '../../../clients/quipli-service/payment/payment';
import { CashPaymentInput } from '../../payment/cash-payment-input';
import { round } from 'lodash';
import { useEffect } from 'react';

export const PaymentTotalSelector = ({
  paymentMethodType,
  total,
  setPercent,
  percent,
  amount,
  setAmount,
  paymentTotal,
  defaultPercentage,
  setPaymentDate,
}: {
  paymentMethodType?: PaymentMethodType;
  total: number;
  setPercent: (percent: number) => void;
  percent?: number;
  amount?: string;
  setAmount: (amount: string) => void;
  paymentTotal: number;
  defaultPercentage?: number;
  setPaymentDate?: (date: DateTime | undefined) => void;
}) => {
  const balanceDue = total - paymentTotal;

  useEffect(() => {
    if (balanceDue) {
      if (paymentMethodType !== PaymentMethodType.Cash && (amount === undefined || parseFloat(amount) > balanceDue)) {
        const currentlyPaidPercent = Math.floor((100 * (total - balanceDue)) / total);
        const p = Math.max(defaultPercentage || 0, currentlyPaidPercent);
        setAmount(Math.max(round((p / 100) * total - (total - balanceDue), 2), 0).toFixed(2));
        setPercent(p);
      } else if (amount) {
        setPercent(Math.floor((100 * (total - balanceDue + parseFloat(amount))) / total));
      }
    }
  }, [balanceDue, amount, defaultPercentage, paymentMethodType]);

  return paymentMethodType && paymentMethodType === PaymentMethodType.Cash ? (
    <CashPaymentInput
      balanceDue={balanceDue}
      setAmount={(a) => {
        setAmount(a.toFixed(2));
        setPercent((100 * (total - balanceDue + a)) / total);
      }}
      setPaymentDate={setPaymentDate}
    />
  ) : (
    <>
      <div className="flex gap-2 items-center">
        <input
          className="grow"
          type="range"
          min={Math.floor((100 * (total - balanceDue)) / total)}
          max={100}
          step={1}
          value={percent}
          onChange={(e) => {
            const p = parseInt(e.target.value);
            setPercent(p);
            const a = round((p / 100) * total - (total - balanceDue), 2);
            setAmount(Math.max(a, 0).toFixed(2));
          }}
        />
        <span>{percent && round(percent, 1)}%</span>
      </div>
      <div className="flex items-center">
        <span>$</span>
        <input
          className="grow"
          type="number"
          step="0.01"
          value={amount}
          onChange={(e) => {
            const a = parseFloat(e.target.value);
            setAmount(e.target.value);
            setPercent((100 * (total - balanceDue + a)) / total);
          }}
        />
      </div>
    </>
  );
};
